var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3650",
    "data-name": "Group 3650",
    transform: "translate(-1014 -3614)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_186",
    "data-name": "Ellipse 186",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1014 3614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    transform: "translate(1023.626 3623.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System"
  }, /*#__PURE__*/React.createElement("g", {
    id: "certificate_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MingCute",
    d: "M28.748,0V28.748H0V0ZM15.085,27.859l-.014,0-.085.043-.023,0h0l-.018,0-.085-.043a.026.026,0,0,0-.028.006l0,.013-.02.512.006.024.013.015.124.089.018,0h0l.014,0,.124-.089.015-.019h0l0-.02-.02-.512a.026.026,0,0,0-.019-.022Zm.317-.135-.017,0-.221.111-.012.012h0l0,.013.021.514.006.015h0l.01.009.241.111a.03.03,0,0,0,.034-.01l0-.017-.041-.736a.03.03,0,0,0-.023-.025Zm-.857,0a.028.028,0,0,0-.033.006l-.007.017-.041.736a.027.027,0,0,0,.02.028l.019,0,.241-.111.011-.01h0l0-.014.021-.514,0-.015h0l-.011-.011Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M12.38,2.216a2.4,2.4,0,0,1,3.236-.14l.152.14,2.275,2.275h3.218a2.4,2.4,0,0,1,2.389,2.217l.007.179v3.218l2.275,2.275a2.4,2.4,0,0,1,.14,3.236l-.14.152-2.275,2.275v3.218a2.4,2.4,0,0,1-2.217,2.389l-.179.007H18.044l-2.275,2.275a2.4,2.4,0,0,1-3.236.14l-.152-.14-2.275-2.275H6.887A2.4,2.4,0,0,1,4.5,21.44l-.007-.179V18.044L2.216,15.769a2.4,2.4,0,0,1-.14-3.236l.14-.152,2.275-2.275V6.887A2.4,2.4,0,0,1,6.709,4.5l.179-.007h3.218Zm5.383,8.244-5.084,5.084-2.118-2.117a1.2,1.2,0,1,0-1.694,1.694L11.747,18a1.318,1.318,0,0,0,1.863,0l5.847-5.847a1.2,1.2,0,0,0-1.694-1.694Z",
    transform: "translate(0.3 0.3)",
    fill: "#e4dc73",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7b4c7faa5cd737ebdf899e270deeefc3.svg";
export { ForwardRef as ReactComponent };